// IRS quarterly due dates as [month index, day]. Mirrors the backend's
// _QUARTER_MONTH_DAY in routers/tax.py; Q4 falls in January of the following
// calendar year. Must change in lockstep with the backend, same as
// dueDateToQuarter below.
const QUARTER_DUE = { 1: [3, 15], 2: [5, 15], 3: [8, 15], 4: [0, 15] };

// Mirrors backend routers/tax.py::_adjust_weekend — Saturday rolls forward two
// days, Sunday one, so a deadline always lands on a Monday rather than a
// weekend. Note the day numbering differs from Python's: JS getDay() is
// Sunday-0, Python weekday() is Monday-0.
function adjustWeekend(d) {
  const day = d.getDay();
  if (day === 6) return new Date(d.getFullYear(), d.getMonth(), d.getDate() + 2); // Sat
  if (day === 0) return new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1); // Sun
  return d;
}

// Weekend-adjusted deadline for a (tax year, quarter) as a local-midnight Date.
// Returns null for an unknown quarter. Output always lands on day 15, 16 or 17,
// which is exactly the window dueDateToQuarter accepts.
export function quarterDueDate(taxYear, quarter) {
  const entry = QUARTER_DUE[quarter];
  if (!entry) return null;
  const [month, day] = entry;
  const calendarYear = quarter === 4 ? taxYear + 1 : taxYear;
  return adjustWeekend(new Date(calendarYear, month, day));
}

export function dueDateToQuarter(dueDateStr) {
  if (!dueDateStr) return null;
  const d = new Date(dueDateStr + 'T00:00:00');
  if (isNaN(d.getTime())) return null;

  const month = d.getMonth() + 1;
  const year = d.getFullYear();
  const day = d.getDate();

  // Allow 15–17 to handle weekend adjustments from the backend
  if (day < 15 || day > 17) return null;

  if (month === 4) return { tax_year: year,     quarter: 1 };
  if (month === 6) return { tax_year: year,     quarter: 2 };
  if (month === 9) return { tax_year: year,     quarter: 3 };
  if (month === 1) return { tax_year: year - 1, quarter: 4 };

  return null;
}

export function formatDeadlineBadge(dateStr) {
  if (!dateStr) return null;
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const deadline = new Date(dateStr + 'T00:00:00');
  deadline.setHours(0, 0, 0, 0);
  const days = Math.round((deadline - now) / (1000 * 60 * 60 * 24));
  const dateLabel = deadline.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

  if (days < 0) {
    const n = Math.abs(days);
    return { label: `Overdue by ${n} ${n === 1 ? 'day' : 'days'} · was due ${dateLabel}`, urgency: 'overdue' };
  }
  if (days === 0) return { label: `Due today, ${dateLabel}`, urgency: 'critical' };
  if (days === 1) return { label: `Due tomorrow, ${dateLabel}`, urgency: 'critical' };
  return { label: `Due in ${days} days on ${dateLabel}`, urgency: days <= 7 ? 'urgent' : 'normal' };
}
